/* eslint-disable import/prefer-default-export */
/* 龙之谷2 Tencent LI Player Network 配置 */
const env = process.env.NODE_ENV === 'production' ? 'sg' : 'test';

export const LiPassConfig = {
    // 台湾
    tw: {
        env,
        gameID: 29011,
        appID: '6388e2122fa94c9f72bbe6c3ed32f86f',
    },
    // 韩国
    ko: {
        env,
        gameID: 29058,
        appID: '7a84e8dafd5ff8ce01f9ed979de2d52e',
    },
    // 日本
    ja: {
        env,
        gameID: 29058,
        appID: '7a84e8dafd5ff8ce01f9ed979de2d52e',
    },
    // 全球
    global: {
        env,
        gameID: 29059,
        appID: '416a244aabde0dbbbc2c4b9c44f660e0',
    },
};
